import React from 'react'
import clsx from 'clsx'

import { StandardProps } from '../../types/common'

import styles from './GlobalHeader.module.scss'

interface GlobalHeaderProps extends StandardProps {
  /**
   * Html tag to use
   */
  tag?: 'header' | 'div'
  sticky?: boolean
}

export const GlobalHeader: React.FC<GlobalHeaderProps> = ({
  children,
  tag: Tag = 'header',
  className,
  style,
  sticky = false,
  testid = 'global-header',
}) => {
  return (
    <Tag
      className={clsx(
        // TODO: these classes needs to be prefixed with 'hds-' in the design system
        styles['global-header'],
        {
          [styles['global-header_sticky']]: sticky,
        },
        className
      )}
      style={style}
      data-testid={testid}
    >
      {children}
    </Tag>
  )
}
